import React from 'react';
import styled from 'styled-components';
import fn from '../../helpers/fn';
import theme from '../theme';

export default fn(__filename, styled.div`
  box-shadow: 0 1000px 0 1000px white;
  box-sizing:border-box;
  display: flex;
  flex-direction: column;
  overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: ${theme.unit * 20}px;

  ${({ white }) => white && `
    background: white;
  `}

  ${({ fill }) => fill && `
    bottom: 0;
    left: 0;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;

    div + & {
      top: ${theme.unit * 10}px;
    }
  `}
`.withComponent(({
  white, fill, // strip
  ...props
}) => <div {...props} />));



// WEBPACK FOOTER //
// ./src/components/blocks/Fullscreen.js